import { render, staticRenderFns } from "./QRCodeIcon.vue?vue&type=template&id=12f85900&scoped=true&"
import script from "./QRCodeIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./QRCodeIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f85900",
  null
  
)

export default component.exports